/** True iff the passed value is of type SlideNodes */
export function isSlideNodes(value) {
  return typeof value === "object" && value !== null && "slideNodes" in value;
}

/** True iff the scene object is a markup scene object */
export function isMarkupSceneObject(sceneObject) {
  return sceneObject.markupData?.isMarkup === true;
}